import { ApiUrl } from "../utils/modules";

class ArticleEventServices {
  constructor(api) {
    this.api = api;
  }

  getAll() {
    return this.api.get(ApiUrl + "articleEvent/all");
  }

  getOne(id) {
    return this.api.get(ApiUrl + "articleEvent/" + id);
  }

  create(data) {
    return this.api.post(ApiUrl + "articleEvent", data); 
  }

  getGlobalStats(params) {
    return this.api.get(ApiUrl + "articleEvent/stats/global", { params });
  }

  getArticleStatsTable(params) {
    return this.api.get(ApiUrl + "articleEvent/table", { params });
  }

  getArticleEventDetails(articleId, params) {
    return this.api.get(`${ApiUrl}articleEvent/${articleId}/details`, { params }); 
  }
}

export default ArticleEventServices;